import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager,
  persistentMultipleTabManager,
} from "firebase/firestore";

// Cloud Firestore with the settings the production client uses. The Gate 1
// trial reads one document with them; the Realtime Database → Firestore
// migration (its own branch) builds on the same module.
//
// Offline persistence is ON (persistent IndexedDB cache). The native app is a
// single WebView, so it takes the single-tab manager; browsers can have
// several tabs open, so the web takes the multi-tab one.

const isNativeShell = typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();

export const FIRESTORE_SETTINGS = {
  localCache: "persistent",
  tabManager: isNativeShell ? "single" : "multiple",
};

let firestore = null;

export function getGameFirestore(app) {
  if (!firestore) {
    firestore = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: isNativeShell ? persistentSingleTabManager() : persistentMultipleTabManager(),
      }),
    });
  }
  return firestore;
}
